<div>
    <div class="row">
        <div class="col-xl-12">
            <div class="card-box">
                <div class="form-group">
                    <label>Discount Amount</label>
<!--                    <currency-input class="form-control" v-model="customerGroupPricingDelivery.discountAmount.value"-->
<!--                                    :options="{ currency: 'ZAR', currencyDisplay: 'narrowSymbol', autoDecimalDigits: true, hideCurrencySymbolOnFocus: false, precision: 2 }"-->
<!--                                    @input="onDiscountAmountChange"></currency-input>-->
                                        <input type="text"
                                               class="form-control" 
                                               v-model="customerGroupPricingDelivery.discountAmount.value"
                                               :disabled="true"/>
                </div>
                <div class="form-group">
                    <label>Products</label>
                    <div class="table-responsive">
                        <table class="table table-striped table-bordered">
                            <thead>
                            <tr>
                                <th width="30%">Name</th>
                                <!--                                    <th width="20%">Original Price</th>-->
                                <th width="20%">Discount Amount</th>
                                <!--                                    <th width="25%">Price After Discount</th>-->
                            </tr>
                            </thead>
                            <tbody>
                            <tr v-for="product in selectedProducts" :key="product.productId">
                                <td>{{product.name}}</td>
                                <!--                                    <td class="original-price">R{{product.basePrice ? product.basePrice.toFixed(2) : '0.00'}}</td>-->
                                <td class="discount-amount">R{{customerGroupPricingDelivery.discountAmount.value ? customerGroupPricingDelivery.discountAmount.value.toFixed(2) : '0.00'}}</td>
                                <!--                                    <td class="price-after-discount">R{{calculatePriceAfterDiscount(product.basePrice).toFixed(2)}}</td>-->
                            </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
                <div class="form-group">
                    <label>Shipping Addresses</label>
                    <div class="table-responsive shipping-address-table" v-if="shippingAddresses.length > 0">
                        <table class="table table-striped table-bordered">
                            <thead>
                            <tr>
                                <th width="20%">Site Name</th>
                                <th width="25%">Street Address</th>
                                <th width="15%">City</th>
                                <th width="12%">Postal Code</th>
                                <th width="20%">Zone</th>
                            </tr>
                            </thead>
                            <tbody>
                            <tr v-for="address in selectedShippingAddresses" :key="address.companyAddressId">
                                <td>{{address.siteName || 'N/A'}}</td>
                                <td>{{address.streetAddress || 'N/A'}}</td>
                                <td>{{address.city || 'N/A'}}</td>
                                <td>{{address.postalCode || 'N/A'}}</td>
                                <td>{{address.zone || 'N/A'}}</td>
                            </tr>
                            </tbody>
                        </table>
                    </div>
                    <div v-else class="alert alert-info">
                        <i class="fa fa-info-circle"></i> No shipping addresses found for the selected customer. Please select a customer first or add shipping addresses for this customer.
                    </div>
                </div>
                <div class="form-group">
                    <label>Effective Date</label>
                    <input type="text"
                           class="form-control"
                           :value="$filters.dateDefaultStandard(customerGroupPricingDelivery.effectiveDate.value, false)"
                           :disabled="true"/>
                </div>
<!--                <button class="btn btn-primary mr-2" @click="saveDeliveryPricing" :disabled="loading">Save</button>-->
                <button class="btn btn-primary" @click.prevent="onBackClick" :disabled="loading">Back</button>
            </div>
        </div>
    </div>

<!--    <error-modal :modalHeading="errorModal.modalHeading"-->
<!--                 :elementId="errorModal.elementId"-->
<!--                 :modalMessage="errorModal.modalMessage"-->
<!--                 :showModal="errorModal.showModal"-->
<!--                 @okClicked="errorModalOkClicked"></error-modal>-->
<!--    <success-modal-->
<!--            :modalHeading="successModal.modalHeading"-->
<!--            :elementId="successModal.elementId"-->
<!--            :modalMessage="successModal.modalMessage"-->
<!--            :showModal="successModal.showModal"-->
<!--            @okClicked="successModalOkClicked">-->
<!--    </success-modal>-->
</div>
